export enum UserEventTypeEnum {
    login = 0,
    changePassword = 1,
    addUpdatePackage = 2,
    scheduleUpdate = 3,
    createUser = 4,
    deleteUser = 5,
    createProfile = 6,
    deleteProfile = 7,
    createFolder = 8,
    moveFolder = 9,
    deleteFolder = 10,
    renameFolder = 11,
    moveInstallation = 12,
    createDashboard = 13,
    deleteDashboard = 14,
    shareDashboard = 15,
    assignToAllLicenseModule = 16,
    editLicenseModule = 17,
    createBranch = 18,
    deleteBranch = 19,
    editBranch = 20,
    editBranchInstallations = 21,
    logDownload = 22,
    forceLogDownload = 23,
    deleteUpdatePackage = 24,
    machineReset = 25,
    installationReboot = 26,
    openRemoteLinkSession = 27,
    closeRemoteLinkSession = 28,
    deleteInstallations = 29,
    smartLockActivation = 30,
    enableSmartLock = 31,
    insertSmartLockClosingCode = 32,
    generateSmartLockChallengeCode = 33,
    editOrganizationsLicenses = 34,
    forgotPasswordLinkGeneration = 35,
    forgotPasswordResetPassword = 36,
    deviceOnBoarding = 37,
    dataFlowPostDeviceDetails = 38,
    dataFlowPostSkipFailedMessage = 39,
    dataFlowPostModifyMessage = 40,
    dataFlowKillService = 41,
    dataFlowPauseService = 42,
    dataFlowResumeService = 43,
    dataFlowPostRetryFailedMessage = 44,
}

export function GetI18nStringFromUserEventType(val: UserEventTypeEnum): string {
    return `enum.userEventsType.${UserEventTypeEnum[val]}`;
}

const userEventToIcon: Map<UserEventTypeEnum, string> = new Map<UserEventTypeEnum, string>([
    [UserEventTypeEnum.login, "sign-in-alt"],
    [UserEventTypeEnum.changePassword, "key"],
    [UserEventTypeEnum.addUpdatePackage, "file-archive"],
    [UserEventTypeEnum.scheduleUpdate, "calendar-check"],
    [UserEventTypeEnum.createUser, "user-plus"],
    [UserEventTypeEnum.deleteUser, "user-slash"],
    [UserEventTypeEnum.createProfile, "users"],
    [UserEventTypeEnum.deleteProfile, "users-slash"],
    [UserEventTypeEnum.createFolder, "folder-plus"],
    [UserEventTypeEnum.moveFolder, "external-link-alt"],
    [UserEventTypeEnum.deleteFolder, "folder-minus"],
    [UserEventTypeEnum.renameFolder, "italic"],
    [UserEventTypeEnum.moveInstallation, "external-link-alt"],
    [UserEventTypeEnum.createDashboard, "calendar-plus"],
    [UserEventTypeEnum.deleteDashboard, "calendar-minus"],
    [UserEventTypeEnum.shareDashboard, "share-alt"],
    [UserEventTypeEnum.assignToAllLicenseModule, "cubes"],
    [UserEventTypeEnum.editLicenseModule, "cube"],
    [UserEventTypeEnum.createBranch, "store"],
    [UserEventTypeEnum.deleteBranch, "store-slash"],
    [UserEventTypeEnum.editBranch, "store"],
    [UserEventTypeEnum.editBranchInstallations, "store"],
    [UserEventTypeEnum.logDownload, "file-download"],
    [UserEventTypeEnum.forceLogDownload, "file-download"],
    [UserEventTypeEnum.deleteUpdatePackage, "file-archive"],
    [UserEventTypeEnum.machineReset, "wrench"],
    [UserEventTypeEnum.installationReboot, "redo"],
    [UserEventTypeEnum.openRemoteLinkSession, "link"],
    [UserEventTypeEnum.closeRemoteLinkSession, "unlink"],
    [UserEventTypeEnum.deleteInstallations, "trash"],
    [UserEventTypeEnum.smartLockActivation, "lock"],
    [UserEventTypeEnum.enableSmartLock, "lock-open"],
    [UserEventTypeEnum.insertSmartLockClosingCode, "unlock-alt"],
    [UserEventTypeEnum.generateSmartLockChallengeCode, "key"],
    [UserEventTypeEnum.editOrganizationsLicenses, "file-invoice-dollar"],
    [UserEventTypeEnum.forgotPasswordLinkGeneration, "link"],
    [UserEventTypeEnum.forgotPasswordResetPassword, "key"],
    [UserEventTypeEnum.deviceOnBoarding, "cloud-upload-alt"],
    [UserEventTypeEnum.dataFlowPostDeviceDetails, "hdd"],
    [UserEventTypeEnum.dataFlowPostSkipFailedMessage, "forward"],
    [UserEventTypeEnum.dataFlowPostRetryFailedMessage, "redo-alt"],
    [UserEventTypeEnum.dataFlowPostModifyMessage, "envelope-open-text"],
    [UserEventTypeEnum.dataFlowKillService, "power-off"],
    [UserEventTypeEnum.dataFlowPauseService, "pause"],
    [UserEventTypeEnum.dataFlowResumeService, "play"],
]);

export function GetIconFromUserEventType(val: UserEventTypeEnum): string {
    return userEventToIcon.has(val) ? userEventToIcon.get(val) : "server";
}
